<template>
    <pm-custom-dialog v-if="visible" v-model="visible" :close-icon="'tick'">
        <div style="text-align: left; padding: 0 16px 0 16px;">
            <span style="font-size: 16px; line-height: 1.2; font-weight: 600; text-shadow: 0.5px 0.5px 0 #000;">
                {{ dialogData.title }}
            </span>
            <br/>
            <small style="font-size: 16px; font-weight: normal;">
                {{ dialogData.amount }} &times; {{ dialogData.unit_price }} =
                <pm-price :value="dialogData.amount * dialogData.unit_price" />
            </small>
            <br/>
            <div style="margin: 10px 0; height: 1px; background-color: #eee"></div>
        </div>

        <div style="line-height: 0.8; position: fixed; top: 45%; left: 40%; width: 20%; pointer-events: none; text-align: center; font-weight: 600; font-size: 32px;" :style="dialogData.selectionMode !== 'id' && dialogData.toothIds.length !== dialogData.amount ? 'color: #e91e63!important;' : 'color: #333;'">
            {{ dialogData.toothIds.length }}<template v-if="dialogData.selectionMode !== 'id'">/{{ dialogData.amount }}</template><br/>
            <small style="font-size: 14px;">SELECTED</small>
        </div>

        <pm-tooth-chart-jaw :selected="dialogData.toothIds" @updateSelection="updateSelection" />
    </pm-custom-dialog>
</template>
<script>
import PmCustomDialog from "./base-dialog.vue";
import PmToothChartJaw from "../tooth-chart/jaw.vue";
export default {
    components: {
        PmCustomDialog,
        PmToothChartJaw,
    },
    props: {
        dialogData: {
            type: Object,
            default: () => ({}),
        }
    },
    data: () => ({
        visible: false,
    }),
    created() {

    },
    methods: {
        updateSelection(ids) {
            this.dialogData.toothIds = ids;

            if (this.dialogData.selectionMode === 'id') {
                this.dialogData.amount = this.dialogData.toothIds.length;
            }

            this.$bus.$emit('toothIdSelectionUpdated');

        },
        show() {
            this.visible = true;
            if (typeof this.dialogData.toothIds === 'undefined') this.$set(this.dialogData, 'toothIds', []);
            if (typeof this.dialogData.selectionMode === 'undefined' || this.dialogData.amount === 0) this.$set(this.dialogData, 'selectionMode', 'id');
        },
        close() {
            this.visible = false;
            this.$emit('close');
        },
    }
}
</script>
